<div class="col-12">
    <div class="card">
        <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems"
        [listService]="paymentListService" (buttonActionSelected)="buttonActionSelected($event)"
        (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
        (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
        (searchTermChanged)="paymentListService.searchTerm = $event"
        (resetListLayout) = "paymentListService.resetListState($event)"
        (paginationSelected)="paginationUpdated(paymentListService,$event)" [serviceData]="serviceData"
        (pageSizeSelected)="paymentListService.pageSize = $event"></app-list-layout>
    </div>
</div>